import React from "react";
import PropTypes from "prop-types";
import { NavLink, useLocation } from "react-router-dom";
import { contentTypes } from "../../config";

export default function SortButton({ text, to }) {
  const location = useLocation();
  const isDefault =
    [contentTypes.game, contentTypes.printable].every((sort) => !location.pathname.endsWith(sort)) &&
    to === contentTypes.standard;

  return (
    <NavLink
      type="button"
      to={to}
      end
      className={({ isActive }) => `button-flat-color uppercase pt-standards ${isActive || isDefault ? "active" : ""}`}
    >
      {text}
    </NavLink>
  );
}

SortButton.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
